import React, { Children } from 'react';
import Paper from '@mui/material/Paper';

export interface IFloatingActionButtonBarProps {
  children?: React.ReactNode;
}

export function FloatingActionButtonBar(props: IFloatingActionButtonBarProps) {
  const { children } = props;
  if (Children.toArray(children).every(o => !o)) {
    return null;
  }

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        position: 'sticky',
        top: '16px',
        width: '100%',
        maxHeight: 'calc(100vh - 32px)',
        overflowY: 'auto',
        '.embedded-layout__container &': {
          top: '8px',
          maxHeight: 'calc(100vh - 16px)',
        },
      }}
      elevation={4}
    >
      {children}
    </Paper>
  );
}
